import dynamic from 'next/dynamic';

// Component that injects SmartAdServer scripts dynamically
const PublicitatComponent = dynamic(() => import('./Publicitat'), {
    ssr: false
});

export default PublicitatComponent;
